/** @typedef {Awaited<ReturnType<typeof import('@yola/atomic-css-generator').setupGenerator>>} CSSGenerator */

/** @type {CSSGenerator | null} */
let generator = null;

/** @returns {CSSGenerator} */
const get = () => {
  if (!generator) {
    throw new Error('CSS generator is not initialized.');
  }

  return generator;
};

/** @param {CSSGenerator} newGenerator */
const set = (newGenerator) => {
  if (!newGenerator) {
    throw new Error('New generator must be provided.');
  }

  generator = newGenerator;
};

export { get, set };
